import { render, staticRenderFns } from "./HelpDeskRequests.vue?vue&type=template&id=665a4444&scoped=true&"
import script from "./HelpDeskRequests.vue?vue&type=script&lang=js&"
export * from "./HelpDeskRequests.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskRequests.vue?vue&type=style&index=0&id=665a4444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a4444",
  null
  
)

export default component.exports